const $ = require("backboneAdapter").$;
import makeAsync from 'callbackToPromise';

let settingsInternal = {};
export const bootstrap = async function (lng) {
    var url = `//connect.facebook.net/${lng}/sdk.js`;
    let fbSdkPromise = $.ajaxDefaultQ({
        url: url,
        dataType: "script"
    });

    try {
        await fbSdkPromise;
        settingsInternal.appId = await $.getDefaultQ('/CampaignCloud/oauthClient/facebook/appId');
    } catch (error) {
        return error;
    }
    let FB = window.FB;

    FB.init({
        appId: settingsInternal.appId,
        // autoLogAppEvents: true,
        // xfbml: true,
        version: 'v3.2'
    });

    return {
        api: makeAsync(FB.api),
        login: makeAsync(FB.login, true),
        logout: makeAsync(FB.logout, true),
        getLoginStatus: makeAsync(FB.getLoginStatus, true)
    };
};
export const settings = settingsInternal;